module.exports = __webpack_public_path__ + "static/media/icon_occlusal_surface_1.09295b41.svg";